<ngx-doc-viewer
  [url]="documentData().url"
  [viewer]="documentData().viewer || 'url'"
  class="size-full"
  [lang]="documentData().language"
></ngx-doc-viewer>
